import { GeaoPaths } from "./GeaoPaths";

const PrincipalFlowVerticalStepperElements = Object.freeze([
    {
        title: "Personal",
        items: [
            {
                text: "Personal Information",
                path: GeaoPaths.PrincipalPersonalInformation
            },
            {
                text: "Background Information",
                path: GeaoPaths.PrincipalBackgroundInformation
            }
        ]
    },
    {
        title: "Agency",
        items: [
            {
                text: "Office Information",
                path: GeaoPaths.PrincipalAgencyOfficeInformation
            },
            {
                text: "Employee Information",
                path: GeaoPaths.PrincipalAgencyEmployeeInformation
            },
            {
                text: "Financial Information",
                path: GeaoPaths.PrincipalAgencyFinancialInformation
            },
            {
                text: "Additional Information",
                path: GeaoPaths.PrincipalAgencyAdditionalInformation
            }
        ]
    },
    {
        title: "Banking",
        items: [
            {
                text: "Banking Information",
                path: GeaoPaths.PrincipalBankingInformation
            },
            {
                text: "W-9 Tax Form",
                path: GeaoPaths.PrincipalW9TaxForm
            }
        ]
    },
    {
        title: "Errors & Omissions (E&O)",
        items: [
            {
                text: "E&O Policy Information",
                path: GeaoPaths.PrincipalErrorsAndOmissions
            }
        ]
    },
    {
        title: "Finalize",
        items: [
            {
                text: "Review, Sign and Submit",
                path: GeaoPaths.PrincipalReviewAndSign
            },
            {
                text: "Application Submitted",
                path: GeaoPaths.PrincipalApplicationSubmitted
            }
        ]
    }
]);

export default PrincipalFlowVerticalStepperElements;